export default "__VITE_ASSET__DToCTQ6K__"